import { createModel } from 'hox';
import { useState, useEffect } from 'react';
import {
	IMaintenanceField,
	OrderInfo,
	ReturnOrderInfo,
	ReturnItemList,
	ReturnMaintainMaterialList,
	ReturnOtherItemList,
	ThreeGuaranteesList,
} from './vrmBillMaintenanceRoType';

import { maintenanceRoService } from './vrmBillMaintenanceRoService';
import { useGlobalModel } from "@/model/globalModel";
import moment from 'moment';

export const useVrmMaintenanceDetailsModel = createModel(function () {
	const { getCiDictAll, getCiDictByDictCode } = useGlobalModel(() => []);

	//查看详情form
	const [tradeCode, setTradeCode] = useState<string>("");
	const [detailLookForm, setDetailLookForm] = useState<any>({});

	//项目详情列表
	const [itemDetail, setItemDetail] = useState<ReturnItemList[]>([]);
	const [itemDetailVisible, setItemDetailVisible] = useState<boolean>(false);
	//三包详情列表
	const [threeGuaranteesItemDetail, setThreeGuaranteesItemDetail] = useState<ThreeGuaranteesList[]>([]);
	const [threeGuaranteesItemDetailVisible, setThreeGuaranteesItemDetailVisible] = useState<boolean>(false);
	//维修用料详情列表
	const [detailMaterialList, setDetailMaterialList] = useState<ReturnMaintainMaterialList[]>([]);
	const [detailMaterialListVisible, setDetailMaterialListVisible] = useState<boolean>(false);
	//维修用料详情列表
	const [otherItemDetailList, setOtherItemDetailList] = useState<ReturnOtherItemList[]>([]);
	const [otherItemDetailListVisible, setOtherItemDetailListVisible] = useState<boolean>(false);

	useEffect(() => {
		getCiDictAll();
	}, []);

	//维修单信息
	const getDetailOne = async (tradeCode: string) => {
		let { retData } = await maintenanceRoService.one(tradeCode);
		if (retData != null) {
			const newFrom = {
				...retData.orderInfo,
				...retData.returnOrderInfo,
				repairContactName: retData.orderInfo.repairContactName + "(" + retData.orderInfo.repairContactPhone + ")",
				serviceMethod: getCiDictByDictCode(retData.orderInfo.serviceMethod)?.title ?? "",
				serviceType: getCiDictByDictCode(retData.orderInfo.serviceType)?.title ?? "",
				faultClassification: getCiDictByDictCode(retData.orderInfo.faultClassification)?.title ?? "",
				customerVehicleMileage: (retData.orderInfo.customerVehicleMileage ?? "0") as string + "  KM",
				mileage: (retData.orderInfo.mileage ?? "0") as string + "  KM",
				orderType: getCiDictByDictCode(retData.orderInfo.orderType)?.title ?? "",
				invoiceNum: retData.orderInfo.settlementInfo != null ? retData.orderInfo.settlementInfo?.invoiceNum : "",
				invoiceMd5: retData.orderInfo.settlementInfo != null ? retData.orderInfo.settlementInfo?.invoiceMd5 : "",
				invoiceTypeName: retData.orderInfo.settlementInfo != null ? retData.orderInfo.settlementInfo?.invoiceTypeName : "",
				invoiceOperator: retData.orderInfo.settlementInfo != null ? retData.orderInfo.settlementInfo?.invoiceOperator : "",
				invoiceUploadTime: retData.orderInfo.settlementInfo != null ?
					retData.orderInfo.settlementInfo?.invoiceUploadTime != null ?
						moment(retData.orderInfo.settlementInfo?.invoiceUploadTime).format('YYYY-MM-DD HH:mm:ss') : "" : "",

			};
			setDetailLookForm(newFrom);

			if (retData.returnItemList?.length > 0) {
				setItemDetailVisible(true);
				setItemDetail(retData.returnItemList);
			}
			else {
				setItemDetailVisible(false);
			}

			if (retData.threeGuaranteesList?.length > 0) {
				setThreeGuaranteesItemDetailVisible(true);
				setThreeGuaranteesItemDetail(retData.threeGuaranteesList);
			}
			else {
				setThreeGuaranteesItemDetailVisible(false);
			}

			if (retData.returnMaintainMaterialList?.length > 0) {
				setDetailMaterialListVisible(true);
				setDetailMaterialList(retData.returnMaintainMaterialList);
			}
			else {
				setDetailMaterialListVisible(false);
			}

			if (retData.returnOtherItemList?.length > 0) {
				setOtherItemDetailListVisible(true);
				setOtherItemDetailList(retData.returnOtherItemList);
			}
			else {
				setOtherItemDetailListVisible(false);
			}
		}
	};

	return {
		setTradeCode,
		getDetailOne,
		tradeCode,
		detailLookForm,
		itemDetail,
		itemDetailVisible,
		threeGuaranteesItemDetail,
		threeGuaranteesItemDetailVisible,
		detailMaterialList,
		detailMaterialListVisible,
		otherItemDetailList,
		otherItemDetailListVisible
	};

});
